module.exports = __webpack_public_path__ + "img/Delete.842719f5.svg";